import { MeetingSessionOvenMediaReceiverManagerBaseData } from "@kalyzee/kast-web-sdk";
import { useMediaStreamPlaysSound } from "@kalyzee/kast-web-sdk/web-components";
import { OvenMediaReceiverWebRTCSession } from "@kalyzee/kast-web-sdk/webrtc";
import { getAudioContextForVolumeAnalyzer } from "../../helpers/audio";
import { useEffect, useState } from "react";

export interface SessionSoundIndicatorProps {
  userName: string;
  session: OvenMediaReceiverWebRTCSession<MeetingSessionOvenMediaReceiverManagerBaseData>;
  isExpert?: boolean;
  isPeda?: boolean;
  label?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const SessionSoundIndicator = ({
  userName,
  session,
  isExpert,
  isPeda,
  label,
  style,
  className,
}: SessionSoundIndicatorProps) => {
  const [media, setMedia] = useState(session.stream);
  const isPlayingSound = useMediaStreamPlaysSound(
    getAudioContextForVolumeAnalyzer(),
    media,
    {
      samplingInterval: 300, // (ms) 80 -> 300
      analyzer: {
        samplingInterval: 300, // (ms) 80 -> 300
        fftSize: 256, // (samples) 1024 -> 256
        freqRange: "voice",
        //cloneMedia: false, // remote streams don't need cloning for analysis
      },
    },
  );

  useEffect(() => {
    const listener = session?.addEventListener('stream', () => {
      setMedia(session.stream)
    });
    return () => listener?.flush();
  }, [session]);

  if (!isPlayingSound) return null;
  return (
    <div style={{
      backgroundColor: isPeda ? "orange" : (isExpert ? "red" : "cyan"),
      padding: "0.5em",
      borderRadius: "0.5em",
      width: 200,
      justifyContent: "center",
      ...(style ?? {})
    }} className={className}>
      {label ? <b>{label}<br/></b> : null}
      <b>{userName}</b> is playing sound
    </div>
  )
};